import * as React from 'react';

import {
    useTranslation,
    G
} from '@components';
import './RestrictWorker.scss';

interface IProps {
    workId: number;
    oldValues: IFormValues;
    editRestriction: Function;
    handleClose: () => void;
    handleToast: (message: string, success: boolean) => void;
    canEditRestriction: boolean;
}

interface IFormValues {
    id: number;
    workId: number;
    name: string;
    surname: string;
    code: string;
    contractorName: string;
    applicantName: string;
    applicantEmail: string;
    reason: string;
    remarks: string;
    date: any;
}

export function EditRestriction(props: IProps) {

    const { t } = useTranslation();
    const [disabled, setDisabled] = React.useState(false);

    const [applicantName, setApplicantName] = React.useState(props.oldValues.applicantName);
    const [applicantEmail, setApplicantEmail] = React.useState(props.oldValues.applicantEmail);
    const [reason, setReason] = React.useState(props.oldValues.reason);
    const [remarks, setRemarks] = React.useState(props.oldValues.remarks);

    const handleSave = async () => {
        setDisabled(true);

        const id = props.oldValues.id;
        const applicantNameValue = applicantName.trim();
        const applicantEmailValue = applicantEmail.trim();
        const reasonValue = reason.trim();
        const remarksValue = remarks.trim();


        const response = await props.editRestriction(id, applicantNameValue, applicantEmailValue, reasonValue, remarksValue)
        if(response.data.editWorkerRestriction.isError || response.data.editWorkerRestriction.value == 0) {
            props.handleToast(t('Error while editing restriction'), false);
        }else{
            props.handleClose();
        }
    }

    return (
        <div className='restrict-worker-dialog'>
            <G label={t('Name')}>
                <input
                    disabled={true}
                    className='c'
                    type='text'
                    value={props.oldValues.name}
                />
            </G>
            <G label={t('Surname')}>
                <input
                    disabled={true}
                    className='c'
                    type='text'
                    value={props.oldValues.surname}
                />
            </G>
            <G label={t('workerCode')}>
                <input
                    disabled={true}
                    className='c'
                    type='text'
                    value={props.oldValues.code}
                />
            </G>
            <G label={t('Contractor')}>
                <input
                    disabled={true}
                    className='c'
                    type='text'
                    value={props.oldValues.contractorName}
                />
            </G>
            <G label={t('Applicant')}>
                <input
                    disabled={!props.canEditRestriction}
                    className='c'
                    type='text'
                    value={applicantName}
                    onChange={(e) => setApplicantName(e.target.value)}
                />
            </G>
            <G label={t('Applicant email')}>
                <input
                    disabled={!props.canEditRestriction}
                    className='c'
                    type='text'
                    value={applicantEmail}
                    onChange={(e) => setApplicantEmail(e.target.value)}
                />
            </G>
            <G label={t('Date')}>
                <input
                    disabled={true}
                    className='c'
                    type='date'
                    value={props.oldValues.date.split('T')[0]}
                />
            </G>
            <G label={t('Motive')} className='restriction-reason'>
                <textarea
                    disabled={!props.canEditRestriction}
                    className='c'
                    value={reason}
                    onChange={(e) => { setReason(e.target.value) }}
                />
            </G>
            <G label={t('Remarks')} className='restriction-remarks'>
                <textarea
                    disabled={!props.canEditRestriction}
                    className='c'
                    value={remarks}
                    onChange={(e) => { setRemarks(e.target.value) }}
                />
            </G>
            <div className='c' />
            {props.canEditRestriction && <div className='r'>
                <span className='e' />

                <button
                    className='primary'
                    disabled={disabled}
                    onClick={() => {
                        handleSave();
                    }}>
                    {t('Edit')}
                </button>
            </div>}
        </div>
    )
}